__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@copilotkit/react-core/v2", "1.61.2", function() { return Promise.all([__webpack_require__.e(243), __webpack_require__.e(912), __webpack_require__.e(452), __webpack_require__.e(648), __webpack_require__.e(335)]).then(function() { return function() { return __webpack_require__(51576); }; }); });
			register("@emotion/react", "11.14.0", function() { return Promise.all([__webpack_require__.e(587), __webpack_require__.e(452), __webpack_require__.e(69)]).then(function() { return function() { return __webpack_require__(15587); }; }); });
			register("@emotion/styled", "11.14.1", function() { return Promise.all([__webpack_require__.e(644), __webpack_require__.e(452), __webpack_require__.e(668), __webpack_require__.e(815)]).then(function() { return function() { return __webpack_require__(69815); }; }); });
			register("axios", "0.26.1", function() { return __webpack_require__.e(505).then(function() { return function() { return __webpack_require__(72505); }; }); });
			register("axios", "0.27.2", function() { return __webpack_require__.e(844).then(function() { return function() { return __webpack_require__(75844); }; }); });
			register("ilenia", "9.17.1", function() { return Promise.all([__webpack_require__.e(863), __webpack_require__.e(452)]).then(function() { return function() { return __webpack_require__(40863); }; }); });
			register("react-dom", "18.3.1", function() { return Promise.all([__webpack_require__.e(961), __webpack_require__.e(452)]).then(function() { return function() { return __webpack_require__(40961); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(159).then(function() { return function() { return __webpack_require__(96540); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};